<template>
  <div class="row justify-content-center">
    <div v-for="(investment, key) in investments" :key="key" class="col-12 col-sm-6 col-md-5">
      <investment-card :investment="investment" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import InvestmentCard from './InvestmentCard.vue'

export default {
  name: 'InvestmentGrid',

  components: {
    InvestmentCard
  },

  computed: {
    ...mapState({
      investments: store => store.core.investments.opportunities
    })
  }
}
</script>
